import { useTranslation } from 'react-i18next';

/** Spinner with a label while a request is in flight. */
export function Loading({ label }: { label?: string }) {
  const { t } = useTranslation();
  return (
    <div className="fs-loading" role="status">
      <span className="fs-spinner" aria-hidden="true" />
      {label ?? t('common.loading')}
    </div>
  );
}
